import { Component, OnInit, ViewChild } from '@angular/core'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { UserProfileChangeModel } from '../../models/UserProfile.model'
import { ReportsGateway } from '../../gatewasys/reports.gateway'
import * as moment from 'moment'
import { PortalGlobals } from '../../../../app/portalglobals'
import { SearchModel } from '../../models/enrollment-search-details'
import { JqxGridVirtualPaging } from '../../../common/utilclasses/jqxgrid-virtualpaging'
import * as _ from 'lodash'
import { ExcelService } from '../../excel.service'

@Component({
    selector: 'usersinactive',
    templateUrl: 'user-profile.component.html'
})
export class UserProfileComponent implements OnInit {
    userProfileModel: UserProfileChangeModel[] | null = []
    startdate: Date
    enddate: Date
    saveSuccess: string
    message: string
    loading: boolean
    searchModel: SearchModel
    totalCount: number = 0
    jqxgridvirtualpaging: JqxGridVirtualPaging
    public loadingusers: boolean = false
    showUsersSearch: boolean = false
    chunkSize: number = 10000
    public loadingPDF: boolean = false

    @ViewChild('usersearchgrid', { static: true }) UserSearchGrid: jqxGridComponent

    Source: any = {
        dataFields: [
            { name: 'LoginID', type: 'string' },
            { name: 'Name', type: 'string' },
            { name: 'User_Type', type: 'string' },
            //{ name: 'Carriers', type: 'string' },
            //{ name: 'RecieveAdminEmail', type: 'string' },
            { name: 'Changed_By', type: 'string' },
            { name: 'ChangedDate', type: 'string' }
        ],
        dataType: 'json',
        localData: this.userProfileModel,
        totalrecords: this.totalCount,
        pagenum: 0,
        pagesize: 50
    }

    ready = (): void => {
        this.UserSearchGrid.localizestrings(this.jqxgridvirtualpaging.ready())
    }

    updatefilterconditions = (type: string, defaultconditions: any): string[] | undefined => {
        return this.jqxgridvirtualpaging.updatefilterconditions(type)
    }

    onSortPortal(event: any): void {
        this.onSort(event, this.searchModel)
        this.GetUserSearchData(this.searchModel)
    }
    onSort(event: any, fmoModel: SearchModel): void {
        let sortinformation = event.args.sortinformation
        let sortdirection = sortinformation.sortdirection.ascending ? 'ASC' : 'DESC'
        if (!sortinformation.sortdirection.ascending && !sortinformation.sortdirection.descending) {
            sortdirection = ''
        }
        if (sortdirection) {
            fmoModel.SortFields = `${sortinformation.sortcolumn} ${sortdirection}`
        } else {
            fmoModel.SortFields = ''
        }
    }
    onPortalPageSizeChanged(event: any): void {
        let args = event.args
        this.Source.pagesize = this.searchModel.PageSize = args.pagesize

        this.GetUserSearchData(this.searchModel)
    }

    onFilter(event: any): void {
        let filterinfo = this.UserSearchGrid.getfilterinformation()
        this.searchModel.FilterCriteria = this.jqxgridvirtualpaging.onFilter(event, filterinfo)
        this.GetUserSearchData(this.searchModel)
    }

    columns: any[] = [
        { text: 'Login ID', dataField: 'LoginID', width: 250 },
        { text: 'Name', dataField: 'Name', width: 280 },
        { text: 'User Type', dataField: 'User_Type', width: 300 },
        //{ text: 'Carrier(s)', dataField: 'Carriers', width: 100 },
        //{ text: 'Receive Admin Email', dataField: 'RecieveAdminEmail', width: 180 },
        { text: 'Changed By', dataField: 'Changed_By', width: 280 },
        { text: 'Changed Date', dataField: 'ChangedDate', width: 200 }
    ]

    dataAdapter: any = new jqx.dataAdapter(this.Source)

    renderPortalGridRows = (params: any): any[] | null => {
        if (params !== null && params.data !== null) {
            if (params.data.length > this.searchModel.PageSize) {
                params.endindex = params.data.length
                params.startindex = params.data.length - this.searchModel.PageSize
            }
            if (!isNaN(params.startindex)) {
                this.searchModel.PageNumber = Math.floor(params.startindex / this.searchModel.PageSize) + 1
                this.loading = true
                this.userProfileModel = this._reportsGateway.getUserProfileChangeSync(this.searchModel)

                if (this.userProfileModel !== undefined && this.userProfileModel.length > 0) {
                    this.userProfileModel.map(
                        (row) => {
                            row.ChangedDate = moment(row.ChangedDate).format('M/D/YYYY')
                            this.loading = false
                        },
                        (err) => {
                            this.loading = false
                        }
                    )
                } else {
                    this.loading = false
                }
            }
        }
        return this.userProfileModel
    }

    GetUserSearchData(UserModel: SearchModel) {
        this.loading = true

        if (UserModel === undefined || UserModel === null) UserModel = this.searchModel

        this._reportsGateway.getUserProfileChange(UserModel).subscribe(
            (usersinactive: UserProfileChangeModel[]) => {
                if (usersinactive !== null && usersinactive.length > 0) {
                    this.showUsersSearch = true
                    this.userProfileModel = usersinactive
                    this.Source.localdata = this.userProfileModel
                    this.totalCount = this.Source.totalrecords = usersinactive[0].TotalCount || 0

                    this.dataAdapter.dataBind()
                    this.UserSearchGrid.updatebounddata()
                    this.loading = false
                    this.message = ''
                } else {
                    this.userProfileModel = null
                    this.Source.localdata = this.userProfileModel
                    this.totalCount = 0

                    this.dataAdapter.dataBind()
                    this.UserSearchGrid.updatebounddata()

                    this.message = 'No Data Found'
                    this.showUsersSearch = false
                }
                this.loading = false
            },
            (error) => {
                this.loading = false
            }
        )
    }

    constructor(private _reportsGateway: ReportsGateway, private _excelService: ExcelService, public _global: PortalGlobals) {
        this.jqxgridvirtualpaging = new JqxGridVirtualPaging()
    }

    ngOnInit() {
        this.searchModel = {} as SearchModel
        let today = new Date()
        var year = 0
        if (this._global.selectedPlanYear == undefined || this._global.selectedPlanYear == null || this._global.selectedPlanYear == 0) {
            year = Number(localStorage.getItem('curPlanYear'))
        } else {
            localStorage.setItem('curPlanYear', this._global.selectedPlanYear.toString())
            year = this._global.selectedPlanYear
        }

        var day = 7
        this.searchModel.StartDate = moment(today).subtract(day, 'day').format('M/D/YYYY')
        console.log('start date: ' + this.startdate)

        this.searchModel.EndDate = moment(today).format('M/D/YYYY')
        this.saveSuccess = ''

        this.searchModel.PageNumber = 1
        this.searchModel.PageSize = 50
        //this.GetUserSearchData(this.FilterCriteria.startDate, this.FilterCriteria.endDate)
    }

    ExportToExcel() {
        this.onExport(this.searchModel, 'Users Profile Changes', this.totalCount)
    }

    onExport(FmoModel: SearchModel, title: string, totalCount: number) {
        let pageNumber = FmoModel.PageNumber
        let pageSize = totalCount
        this.loading = true
        let usersData: UserProfileChangeModel[] = [] as UserProfileChangeModel[]

        FmoModel.PageNumber = 1
        FmoModel.PageSize = totalCount
        usersData = this.pickGateWayMethod(FmoModel, title)
    }

    pickGateWayMethod(model: SearchModel, title: string) {
        let data: UserProfileChangeModel[] = [] as UserProfileChangeModel[]
        let pageNumber = model.PageNumber
        let pageSize = model.PageSize

        this._reportsGateway.getUserProfileChange(model).subscribe(
            (data) => {
                data = data

                for (var i = 0; i < data.length; i++) {
                    var row = data[i]
                    if (row.ChangedDate !== null) {
                        row.ChangedDate = moment(row.ChangedDate).format('M/D/YYYY')
                    }
                }

                if (data !== null && data.length > 0) {
                    let array = _.clone(data)

                    array.forEach(function (v) {
                        delete v.TotalCount
                        delete v.Carriers
                        delete v.RecieveAdminEmail
                        delete v.ChangedBy
                        delete v.FirstName
                        delete v.LastName
                        delete v.UserProfileStatusCode
                    })

                    let strArray = JSON.stringify(array)
                    strArray = strArray.replace(/LoginID/g, 'Login ID')
                    strArray = strArray.replace(/Name/g, 'Name')
                    strArray = strArray.replace(/User_Type/g, 'User Type')
                    //strArray = strArray.replace(/Carriers/g, 'Carriers')
                    //strArray = strArray.replace(/RecieveAdminEmail/g, 'Recieve Admin Email')
                    strArray = strArray.replace(/Changed_By/g, 'Changed By')
                    strArray = strArray.replace(/ChangedDate/g, 'Changed Date')

                    let modEnrollmentData = JSON.parse(strArray)
                    this._excelService.exportAsExcelFile(modEnrollmentData, title)
                    model.PageNumber = pageNumber
                    model.PageSize = pageSize
                    this.loading = false
                } else {
                    this.loading = false
                    this.message = 'No Data Found'
                }
            },
            (error) => {
                this.loading = false
            }
        )

        return data
    }
}
